import React from 'react'

function H1bdocumentation() {
  return (
    <div>H1bdocumentation</div>
  )
}

export default H1bdocumentation